<vectronic-card
  [attr.data-testid]="'add-collar-group'"
  [title]="'Add Collar & Group'"
  [displayClose]="true"
  (closed)="dialogRef.close()"
>
  <div body>
    <div class="collar-checklist">
      <mat-form-field class="collar-checklist__filter" appearance="outline">
        <mat-label>Filter</mat-label>
        <input
          matInput
          placeholder="Collar/Group"
          [attr.data-testid]="'collars-groups-filter'"
          [formControl]="formControl"
        />
      </mat-form-field>
      <div class="collar-checklist__container">
        @if (!filteredCollarsAndGroups?.length) {
          <div class="collar-checklist__error-empty">
            <div>Nothing available!</div>
          </div>
        }
        @if (filteredCollarsAndGroups?.length) {
          <div class="collar-checklist__all-selected">
            <div>Selected All</div>
            <mat-checkbox
              [(ngModel)]="selectedAll"
              (ngModelChange)="onSelectedAll()"
            ></mat-checkbox>
          </div>
        }
        <mat-selection-list #selectionList>
          <cdk-virtual-scroll-viewport
            [attr.data-testid]="'collars-groups'"
            [itemSize]="48"
            class="collar-checklist__viewport"
          >
            <mat-list-option
              *cdkVirtualFor="let collar of filteredCollarsAndGroups"
              [value]="collar.collarId || collar.group?.id"
              (click)="onSelectedChange(collar.collarId || collar.group?.id)"
              [selected]="isSelected(collar.collarId || collar.group?.id)"
              [attr.data-testid]="'collars-groups-' + (collar.collarId || collar.group?.id)"
            >
              <div class="collar-checklist__option">
                {{ collar.collarId || collar.group?.name }}
                @if (collar.group) {
                  <mat-icon svgIcon="object-multi-group"> </mat-icon>
                }
              </div>
            </mat-list-option>
          </cdk-virtual-scroll-viewport>
        </mat-selection-list>
      </div>
      <div class="collar-checklist__submit">
        <button
          mat-button
          [attr.data-testid]="'submit-collars-groups'"
          (click)="onClickCollarsAndGroups()"
        >
          <mat-icon color="accent">send</mat-icon>
          Submit
        </button>
      </div>
    </div>
  </div>
</vectronic-card>
